import gql from "graphql-tag";
import { useRefetchableQuery } from "core/hooks/useRefetchableQuery";
import {
  GetBuildingSupervisors_buildingConnections_buildings as BuildingsDataGenerated,
  GetBuildingSupervisors_buildingConnections_buildings_cleaningSupervisors as GetBuildingSupervisorsCleaningSupervisorsGenerated,
  GetBuildingSupervisors as GetBuildingSupervisorsGenerated,
  GetBuildingSupervisorsVariables as GetBuildingSupervisorsVariablesGenerated,
} from "core/queries/__generated__/GetBuildingSupervisors";

// Queries
export interface BuildingsData extends BuildingsDataGenerated {}
export interface GetBuildingSupervisorsResponse
  extends GetBuildingSupervisorsGenerated {}
export interface GetBuildingSupervisorsVariables
  extends GetBuildingSupervisorsVariablesGenerated {}
export interface GetBuildingSupervisorsCleaningSupervisors
  extends GetBuildingSupervisorsCleaningSupervisorsGenerated {}

export const getBuildingSupervisors = gql`
  query GetBuildingSupervisors($filter: BuildingFilterInput) {
    buildingConnections(filter: $filter) {
      buildings {
        id
        shortInternalRef
        cleaningSupervisors {
          id
          avatar: profilePicture {
            id
            url
          }
          email
          firstName
          lastName
          name
        }
      }
    }
  }
`;

export interface UseRefetchableGetBuildingSupervisorsQueryOptions {
  skip?: boolean;
  pollInterval: number;
  variables: GetBuildingSupervisorsVariables;
}

export const useRefetchableGetBuildingSupervisorsQuery = ({
  pollInterval,
  skip,
  variables,
}: UseRefetchableGetBuildingSupervisorsQueryOptions) =>
  useRefetchableQuery<
    GetBuildingSupervisorsResponse,
    GetBuildingSupervisorsVariables
  >(getBuildingSupervisors, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    pollInterval,
    skip,
    variables,
  });
